export const selectMachine = (state) => state.machineState.machine;
export const selectJoints = (state) => state.machineState.joints;
export const selectToolLengthOffset = (state) => state.machineState.tool.table[state.machineState.tool.loaded].Z
